<template>
  <div class="page404">
    <div class="wrapper">
      <h1>404</h1>
      <div class="page404__name">страница не найдена</div>
      <div class="page404__text">
        Страница, на которую вы патаетесь<br>
        попасть, не существует или была удалена.<br><br>
        <a href="/" title="На главную страницу">Главная страница</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Page404"
  }
</script>

<style lang="scss" scoped>
h1 {
  margin: 20px 0 0;
  text-align: center;
  @include font(130px, 1, #082e76);
  text-shadow: 3px 3px 5px #082e76;

  @media screen and (min-width: 1024px){
    margin: 40px 0 0;
    @include font(220px, 1, #082e76);
  }
}

.page404 {
  position: relative;
  text-align: center;

  &__name {
    @include font(20px, 1, #082e76);

    @media screen and (min-width: 1024px){
      @include font(26px, 1, #082e76);
    }
  }

  &__text {
    margin: 50px 0 0;
  }
}
</style>
